import { DeviceOS } from 'enums';

const getDeviceOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/android/.test(userAgent)) {
    return DeviceOS.Android;
  }
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return DeviceOS.IOS;
  }
  if (/windows/.test(userAgent)) {
    return DeviceOS.Desktop;
  }
  if (/mac os x/.test(userAgent) && !/android/.test(userAgent)) {
    return DeviceOS.Desktop;
  }
  if (/linux/.test(userAgent)) {
    return DeviceOS.Desktop;
  }
  // eslint-disable-next-line no-console
  console.warn('Device OS is not detected');
  return '';
};

export const userDeviceUtils = {
  getDeviceOS,
};
